import ErrorBox from '@components/common/ErrorBox';
import Button from '@stone/ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ReturnExchangeInBoutique from '@stone/components/returns/ReturnExchangeInBoutique';
import classNames from 'classnames';
import { addURLParameters } from '@common/utils/urlutils';
const ReturnsGuestForm = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errorMessage, setErrorMessage] = useState();
    useEffect(() => {
        let val = {};
        api.getForm('returns', val).then((data) => {
            setFormdef(data);
            setInitialValues(val);
        });
    }, []);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'returns');
    };
    const onSubmit = async (values) => {
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        api.openReturn(values.orderNumber, values.email, props.isExchange).then((result) => {
            if (!result.success) {
                setErrorMessage([result.errorMessage]);
                return;
            }
            // props.isExchange ? analytics.exchangeStepOne('proceed') : analytics.returnsStepOne('proceed');
            window.location.href = addURLParameters(props.isExchange ? props.openexchangeurl : props.openreturnurl, {
                orderId: values.orderNumber,
                token: result.token,
            });
        });
    };
    const returnForm = () => (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "return__description mb-40", dangerouslySetInnerHTML: { __html: t('returns.description') } }),
        React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit, className: "d-column gap-40" },
                React.createElement(DwFormField, { def: formdef, name: "orderNumber", autocomplete: "orderNumber", placeholder: t('returns.form.ordernumber.placeholder') }),
                React.createElement(DwFormField, { def: formdef, name: "email", autocomplete: "email", placeholder: t('returns.form.email.placeholder') }),
                React.createElement("div", { className: "row row-gap-12" },
                    !window.appmode && !props.loggedUser && (React.createElement("div", { className: "col-24 col-lg-12" },
                        React.createElement("a", { href: window.loginUrl, className: "button button--secondary full" },
                            React.createElement("span", null, t('button.login'))))),
                    React.createElement("div", { className: classNames('col-24 col-lg-12', { 'offset-lg-12': props.loggedUser }) },
                        React.createElement(Button, { type: "submit", disabled: submitting, fullWidth: true }, t('button.proceed')))),
                React.createElement(ErrorBox, { errors: errorMessage, className: "mt-20" }))) })));
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { className: "tabs tabs--fluid tabs--capitalize tabs--centered tabs--fit" },
            React.createElement(TabList, { className: "react-tabs__tab-list client-service__tablist" },
                React.createElement(Tab
                // onClick={() => {
                //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabonlineanalytics').toLowerCase());
                // }}
                , { 
                    // onClick={() => {
                    //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabonlineanalytics').toLowerCase());
                    // }}
                    onClick: () => props === null || props === void 0 ? void 0 : props.onTabChange(0) }, props.isExchange ? t('exchanges.tabonline') : t('returns.tabonline')),
                !window.faf && !window.appmode && !window.isClothing && (React.createElement(Tab
                // onClick={() => {
                //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabboutiqueanalytics').toLowerCase());
                // }}
                , { 
                    // onClick={() => {
                    //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), t('returns.tabboutiqueanalytics').toLowerCase());
                    // }}
                    onClick: () => props === null || props === void 0 ? void 0 : props.onTabChange(1) }, props.isExchange ? t('exchanges.tabboutique') : t('returns.tabboutique')))),
            React.createElement(TabPanel, { className: "client-service__tabpanel" }, formdef && returnForm()),
            !window.faf && (React.createElement(TabPanel, null,
                React.createElement(ReturnExchangeInBoutique, Object.assign({}, props)))))));
};
export default ReturnsGuestForm;
